module.exports = __webpack_public_path__ + "static/media/chevron-down.9c04e8a1.svg";